/**
 * @file 欢迅会员中心（huanxunnewVipRecharge）图片资源集中导出
 * @description
 *   开发期：`images/` 本地加载。
 *   上线 CDN：USE_CDN 改 true，图片上传到 CDN_PREFIX 目录，业务组件无需改动。
 *   会员权益图标按列表顺序走 icon-1.png / icon-2.png …
 */
import AvalonGTConfig from '@/utils/Config';
/** 上线 CDN 后改为 true */
var USE_CDN = true;
/** CDN 路径前缀（与 getH5ImgUrl 拼接） */
var CDN_PREFIX = 'vip/huanxun/';
function img(name) {
    return AvalonGTConfig.Global.getH5ImgUrl(CDN_PREFIX + name);
}
/** 按序号取权益图标：icon-1.png / icon-2.png … */
function privilegeIcon(n) {
    return img("icon-" + n + ".png");
}
var vipImgs = {
    /** 顶部深色金纹背景（含会员卡） */
    heroBg: img('hero-bg.png'),
    /** 「会员中心」钻石图标 */
    iconVip: img('icon-vip.png'),
    /** 区块标题左侧装饰线 */
    titleLineLeft: img('title-line-left.png'),
    /** 区块标题右侧装饰线 */
    titleLineRight: img('title-line-right.png'),
    /** 套餐卡选中态背景 */
    planBgActive: img('plan-bg-active.png'),
    /** 套餐卡未选中态背景 */
    planBgNormal: img('plan-bg-normal.png'),
    /** 套餐卡「推荐」角标（含文字） */
    tagRecommend: img('tag-bg.png'),
    /** 按序号取权益图标 */
    privilegeIcon: privilegeIcon,
};
export default vipImgs;
